import React, {useState} from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import Helper from '../../../../utilities/helper';
import SupportedTV from '../SupportedTV/SupportedTV';
import {displaySupportedTV} from '../SupportedTV/SupportedTVSlice';
import {reportAnalytics} from './saleProductsSlice';
import {addTotalPrice} from '../saleBlockSlice';
import tvIcon from './images/tv-icon.svg';
const SaleProducts = (props) => {
  const isReachedMaxLimit = props.productsInfo.products.length >= props.service.maximumProducts;
  const [openRemark, setOpenRemark] = useState(false);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.productsInfo.products.map((productInfo, index) => {
        productInfo.products.map((product, key) => {
          props.addTotalPrice(product.additionalPrice);
        });
      });
    }
  }, []);

  const displaySupportedTVHandler = () => {
    switch (props.saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: 'click_21',
          eventLabel: '',
        });
        break;
      case 'app':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: 'click_36',
          eventLabel: '',
        });
        break;
    }
    props.displaySupportedTV(true);
  };

  return (
    <div className='sale-products'>
      <div className='sale-product-list'>
        {props.productsInfo.products.map((productObj, index) => {
          const products = productObj.products;
          return (
            <div className='sale-product' key={index}>
              {productObj.count > 1 ? (
                products.map((product, key) => {
                  return (
                    <div
                      role='button'
                      tabIndex='0'
                      onKeyPress={(e) => Helper.onKeyPress(e, handleOnChangeProductClick(index, product))}
                      key={key}
                      onClick={() => handleOnChangeProductClick(index, product)}
                      className={`product-name ${key > 0 ? 'additional' : ''}`} style={{backgroundImage:tvIcon.bg()}}>
                      <div className={`product-wrapper ${product.isSelected ? 'selected' : 'not-selected'}`}>
                        <div> {product.name}</div>
                        <div className='product-remark'>
                          {product.additionalPrice == null || product.additionalPrice == 0
                            ? 'כלול בחבילה'
                            : ' תוספת' + ' ' + '₪' + product.additionalPrice}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className='product-name' tabIndex='0' style={{backgroundImage:tvIcon.bg()}}>
                  <div> {products[0].name}</div>
                  <div className='product-remark'>
                    {products[0].additionalPrice == null || products[0].additionalPrice == 0
                      ? 'כלול בחבילה'
                      : ' תוספת' + ' ' + '₪' + products[0].additionalPrice}
                  </div>
                </div>
              )}

              {props.productsInfo.products.length > 1 && index > 0 && (
                <a
                  role='button'
                  aria-label='הסר מוצר'
                  className='btn-delete-product'
                  href='#'
                  onClick={() => {
                    handleRemoveProductClick(index);
                  }}></a>
              )}
            </div>
          );
        })}
      </div>

      {isReachedMaxLimit ? (
        <div className='max-limit-message' tabIndex='0'>
          {' '}
          הגעתם למקסימום הממירים שאפשר להזמין{' '}
        </div>
      ) : (
        <div className='sale-product-btn-wrapper'>
          <a className='btn-add-settopbox' href='#' onClick={handleAddProductClick}>
            {' '}
            הוספת ממיר{' '}
          </a>
        </div>
      )}

      <div className='sale-product-remarks' tabIndex='0' role='button' onClick={() => toggleOpenRemarks()}>
        <div className={`remark-row info-icon info-icon-white`}> שווה לדעת: בטלוויזיות חכמות אפשר לצפות גם בלי ממיר </div>
        {openRemark && (
          <div>
            <div className='remark-row'>
              <a href='#' onClick={() => displaySupportedTVHandler()}>
                {'לרשימת הדגמים הנתמכים >'}
              </a>
            </div>
            <div className='remark-row'> אם הטלוויזיה שלכם נתמכת, תוכלו להוריד ממיר אחד מההזמנה </div>
          </div>
        )}
      </div>

      <SupportedTV supportedTVText={props.saleBlock.supportedTVText} />
    </div>
  );

  function handleAddProductClick() {
    const index = props.productsInfo.products.length;
    props.onAddProduct(index);
  }

  function handleOnChangeProductClick(index, product) {
    props.onChangeProduct(index, product);
  }

  function handleRemoveProductClick(index) {
    props.onRemoveProduct(index);
  }

  function toggleOpenRemarks() {
    let isOpenRemark = !openRemark;
    setOpenRemark(isOpenRemark);
  }
};

const mapStateToProps = (state) => {
  return {
    saleBlock: state.saleBlock.epiServer.saleBlock
  };
};

const mapDispatchToProps = {
  displaySupportedTV,
  reportAnalytics,
  addTotalPrice,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleProducts);
